import React from 'react';

const SvgTz = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="TZ_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="TZ_svg__b" fill="#fff">
        <use xlinkHref="#TZ_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#TZ_svg__a" />
      <path fill="#33CC4D" mask="url(#TZ_svg__b)" d="M0 13.333L28 0H0z" />
      <path fill="#2DAFE4" mask="url(#TZ_svg__b)" d="M0 20h28V6.667z" />
      <path
        fill="#FFD84F"
        mask="url(#TZ_svg__b)"
        d="M3.082 22.667L30.171 5.74l-5.253-8.407L-2.171 14.26z"
      />
      <path
        fill="#262626"
        mask="url(#TZ_svg__b)"
        d="M-.63 23.072l32.792-20.49-3.533-5.654-32.791 20.49z"
      />
    </g>
  </svg>
);

export default SvgTz;
